import React from 'react';
import { Flex, Text } from '@chakra-ui/react';
import { ButtonText } from '@morressier/alembic';
import { FormFieldFiguresAndTables } from '@publishing-engine/domain/types/article';

type IProps = {
  fieldLabels: FormFieldFiguresAndTables['params']['labels'];
  editCallback?: () => void;
};

export const FiguresAndTablesEmptyState: React.FC<IProps> = ({
  editCallback
}) => (
  <Flex
    flexDirection={'column'}
    backgroundColor={'surfaceTertiaryFill'}
    padding={4}
  >
    <Flex alignItems="center" gap={2} flexDirection="row">
      <Text textStyle="textBody">No Figure or Table provided</Text>
    </Flex>
    <Flex>
      {editCallback && <ButtonText onClick={editCallback}>Update</ButtonText>}
    </Flex>
  </Flex>
);
